import { addCoreDataDictionaryViewsSyncSlice } from './add';
import { CoreDataDictionaryViewsName } from './name';
import { postDataDictionaryView } from '@api';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataDictionaryViewAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				addCoreDataDictionaryViewsSyncSlice.syncActionCreator({
					columns: request.columns,
					filter: request.filter,
					id: response.viewId,
					name: request.viewName,
					ordering: request.ordering
				})
		]
	},
	name: CoreDataDictionaryViewsName,
	receive: true,
	request: true,
	requestHandler: postDataDictionaryView,
	yieldType: SagaYieldType.Every
});
